import React from 'react';
import styles from '../../styles/components/supply-gpu/EmptyState.module.css';

interface EmptyStateProps {
  onAddMachine: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ onAddMachine }) => {
  return (
    <div 
      className={styles.emptyState}
      role="region"
      aria-labelledby="empty-state-title"
      aria-describedby="empty-state-description"
    >
      <img 
        className={styles.iconDeviceNotFind} 
        alt="" 
        src="/icons/device_not_find.svg" 
      />
      
      <div className={styles.textContent}>
        <h2 
          id="empty-state-title"
          className={styles.title}
        >
          Connect the machine
        </h2>
        
        <p 
          id="empty-state-description"
          className={styles.description}
        >
          Nothing here yet. Add a new machine using the button
        </p>
      </div>
    </div>
  );
};

export default EmptyState;